<template>
    <!-- custom filter scenario 3 -->
    <!-- customer filter (admin only) & distance filter -->
    <div class="custom-filter-container pr-20">
        <div class="ml-8 mb-12">
            <!-- custom filter toggle button -->
            <el-button
            color="#0D3937"
            class="toggle-button"
            @click="displayFilter = !displayFilter"
            >
                <svg class="svg-left width-20 height-20">
                    <use href="@/assets/svg/newSvgIcon.svg#customerFilterButton"></use>
                </svg>
                <span class="moderat-white-bold m-l-10 m-r-10">Custom filter</span>
                <svg v-if="displayFilter" class="svg-right width-20 height-20">
                    <use href="@/assets/svg/newSvgIcon.svg#customFilterArrowClose"></use>
                </svg>
                <svg v-else class="svg-right width-20 height-20">
                    <use href="@/assets/svg/newSvgIcon.svg#customFilterArrowOpen"></use>
                </svg>
            </el-button>
        </div>

        <!-- Custom filter -->
        <el-row v-if="displayFilter">
            <div 
            class="custom-filter-container-wrapper row y-center m-0 mt-2 mb-12 mx-2 p-2 bg-me-primary border-color-light rounded-4 width-100-p"
            >
                <el-form :label-position="`top`" class="custom-filter-form">
                <el-space
                    class="custom-filter-space"
                    fill
                    >
                    <!-- include / exclude customers (admin only) -->
                    <el-row gutter="20"
                        v-if="
                            $store.state.auth.user != null &&
                            $store.state.auth.user.is_admin
                        "
                    >
                        <el-col 
                            :span="$vuetify.display.width > 1280 ? 10 : 24" 
                            :class="$vuetify.display.width > 645 ? 'x-start' : 'x-center'" 
                        >
                            <el-form-item
                                class="custom-filter-item label-style"
                                prop="customer"
                                label="Customer"
                                required
                            >
                                <div>
                                    <el-select 
                                        v-model="filter.customer_id" 
                                        placeholder="Select at least one customer"  
                                        class="custom-filter-select"
                                        clearable
                                        filterable
                                        multiple
                                        collapse-tags
                                        collapse-tags-tooltip
                                        :max-collapse-tags="2"
                                        @change="onIncludeCustomersChange"
                                        >
                                        <el-option
                                            v-for="item in includeCustomerOptions"
                                            :key="item.id"
                                            :label="item.full_name"
                                            :value="item.id"
                                            >
                                            <span>{{ item.full_name }}</span>
                                        </el-option>
                                    </el-select>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col 
                            :span="$vuetify.display.width > 1280 ? 10 : 24" 
                            :class="$vuetify.display.width > 645 ? 'x-start' : 'x-center'" 
                        >
                            <el-form-item
                                class="custom-filter-item label-style"
                                prop="excluding_customer_ids"
                                label="Exclude customers"
                            >
                                <div>
                                    <el-select 
                                        v-model="filter.excluding_customer_ids" 
                                        placeholder="Select customers to exclude"  
                                        class="custom-filter-select"
                                        clearable
                                        filterable
                                        multiple
                                        collapse-tags
                                        collapse-tags-tooltip
                                        :max-collapse-tags="2"
                                        @change="onExcludeCustomersChange"
                                        >
                                        <el-option
                                            v-for="item in excludeCustomerOptions"
                                            :key="item.id"
                                            :label="item.full_name"
                                            :value="item.id"
                                            >
                                            <span>{{ item.full_name }}</span>
                                        </el-option>
                                    </el-select>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- location && distance -->
                    <el-row gutter="20">
                        <el-col 
                        :span="$vuetify.display.width > 1280 ? 10 : 24" 
                        :class="$vuetify.display.width > 645 ? 'x-start' : 'x-center'" >
                        <el-form-item
                                class="custom-filter-item label-style"
                                prop="location"
                                label="Electricity Region"
                            >
                                <!-- hierarchical location select -->
                                <div>
                                    <el-tree-select
                                        class="custom-filter-select"
                                        v-model="locationSelection"
                                        :data="treeData"
                                        :render-after-expand="false"
                                        placeholder="Select country or elec region"
                                        clearable
                                        filterable
                                        @change="onTreeLocationChange"
                                    >
                                        <template #default="{ data }">
                                            <span>{{ data.label.replace("_", " ")}}</span>
                                        </template>
                                </el-tree-select>
                                </div>
                            </el-form-item>
                        </el-col>

                        <el-col 
                        :span="$vuetify.display.width > 1280 ? 10 : 24"
                        :class="$vuetify.display.width > 645 ? 'x-start' : 'x-center' ">
                            <el-form-item
                                class="custom-filter-item label-style"
                                prop="distance"
                                label="Distance"
                            >
                                <!-- charger select -->
                                <div>
                                <el-input
                                    class="custom-filter-select"
                                    v-model="filter.distance"
                                    placeholder="Type to search by distance"
                                    clearable
                                />
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-space>
                </el-form>
                <el-row gutter="20" class="custom-filter-button-container float-right mb-20">
                    <el-col :span="24" :class="$vuetify.display.width > 645 ? 'x-start' : 'x-center'">
                    <el-button
                        @click="applyFilter"
                        class="custom-filter-button-apply"
                    >
                        <svg class="width-111 height-40">
                        <use href="@/assets/svg/newSvgIcon.svg#customFilterApplyButton"></use>
                        </svg>
                    </el-button>
                    <el-button
                        @click="resetFilter"
                        class="custom-filter-button-reset"
                    >
                        <svg class="width-112 height-40">
                        <use href="@/assets/svg/newSvgIcon.svg#customFilterResetButton"></use>
                        </svg>
                    </el-button>
                </el-col>
                </el-row>
            </div>
        </el-row>
    </div>
</template>

<script>
import UserService from "../../../services/user.service";
import { shorterLabel, buildElecRegionTreeData, applyTreeLocationSelection, customersForAccess } from "./common-tools";

export default {
    props: {
    },
    data() {
        return {
            displayFilter: false, // toggle display of custom filter
            customers: [],
            countries: [],
            elecRegionsByCountry: {},
            loading: false,            
            filter: {
                customer_id: [],
                excluding_customer_ids: [],
                elec_region: "",
                country: "",
                distance: null,
            },
            locationSelection: "", // Internal selection state for the dropdown
            treeData: [], // Tree structure for countries and elec regions
        }
    },

    async mounted() {
        this.filter.customer_id = this.getDefaultCustomerIds();

        if (
            this.$store.state.auth.user != null &&
            this.$store.state.auth.user.is_admin
        ) {
            this.fetchStates();
            await this.fetchCustomerData();
        } else {
            this.customers = [];
        }

        if (this.hasRequiredFilterValues()) {
            this.emitFilter();
        }
    },

    methods: {
        // change label to shorter label for fixed button length
        shortLabel(inputLabel,length,MaxLength,additional) {
        let label = shorterLabel(inputLabel,length,MaxLength,additional);
        return label;
        },

        normalizeCustomerIds(customer_id) {
            if (customer_id == null || customer_id === "") {
                return [];
            }
            const ids = Array.isArray(customer_id) ? customer_id : [customer_id];
            return ids
                .map((id) => Number(id))
                .filter((id) => Number.isInteger(id) && !Number.isNaN(id));
        },

        getDefaultCustomerIds() {
            const user = this.$store.state.auth.user;
            if (user != null && user.is_admin) {
                return [];
            }
            const customerId = user?.customer_id;
            if (customerId == null || customerId === "") {
                return [];
            }
            return this.normalizeCustomerIds(customerId);
        },

        hasRequiredFilterValues() {
            return this.normalizeCustomerIds(this.filter.customer_id).length > 0;
        },

        emitFilter() {
            this.filter.customer_id = this.normalizeCustomerIds(this.filter.customer_id);
            this.filter.excluding_customer_ids = this.normalizeCustomerIds(this.filter.excluding_customer_ids);
            this.$emit("filterHandle", { ...this.filter });
        },

        onIncludeCustomersChange() {
            const included = new Set(this.normalizeCustomerIds(this.filter.customer_id));
            this.filter.excluding_customer_ids = this.normalizeCustomerIds(this.filter.excluding_customer_ids)
                .filter((id) => !included.has(id));
        },

        onExcludeCustomersChange() {
            const excluded = new Set(this.normalizeCustomerIds(this.filter.excluding_customer_ids));
            this.filter.customer_id = this.normalizeCustomerIds(this.filter.customer_id)
                .filter((id) => !excluded.has(id));
        },

        async fetchCustomerData() {
            this.loading = true;
            await UserService.getCustomers(null, "", 1, 50)
                .then(
                (response) => {
                    if (!response || !response.data || !response.data.customers) {
                        this.customers = [];
                    } else {
                        this.customers = customersForAccess(response.data.customers, this.$store.state.auth.user);
                    }
                },
                (error) => {
                    this.loading = false;
                    console.log(error.message);
                    if (error.response.status == 401) {
                    this.$router.push({
                        path: "/",
                    });
                    }
                }
                )
                .catch((error) => {
                this.loading = false;
                console.log(error.message);
                if (error.response.status == 401) {
                    this.$router.push({
                    path: "/",
                    });
                }
                })
                .finally(() => (this.loading = false));
        },

        async fetchStates() {
            await UserService.ChargerMapGroupGetStates()
                .then(response => {
                    if (response.data && response.data.data) {
                        this.countries = Object.keys(response.data.data);
                        this.elecRegionsByCountry = response.data.data;
                        this.treeData = buildElecRegionTreeData(this.elecRegionsByCountry);
                    }
                });
        },

        onTreeLocationChange(value) {
            const next = applyTreeLocationSelection(value, this.elecRegionsByCountry);
            this.filter.country = next.country;
            this.filter.elec_region = next.elec_region;
            this.locationSelection = next.locationSelection;
        },

        applyFilter() {
            const customerIds = this.normalizeCustomerIds(this.filter.customer_id);
            if (customerIds.length === 0) {
                this.$message.error("Please select at least one customer.");
                return;
            }
            this.filter.customer_id = customerIds;
            this.emitFilter();
        },

        async resetFilter() {
            this.locationSelection = "";
            this.filter = {
                customer_id: this.getDefaultCustomerIds(),
                excluding_customer_ids: [],
                elec_region: "",
                country: "",
                distance: null,
            };
            if (
                this.$store.state.auth.user != null &&
                this.$store.state.auth.user.is_admin
            ) {
                await this.fetchCustomerData();
            }
            this.emitFilter();
        },
    },

    computed: {
        includeCustomerOptions() {
            const excluded = new Set(this.normalizeCustomerIds(this.filter.excluding_customer_ids));
            return this.customers.filter((item) => !excluded.has(Number(item.id)));
        },
        excludeCustomerOptions() {
            const included = new Set(this.normalizeCustomerIds(this.filter.customer_id));
            return this.customers.filter((item) => !included.has(Number(item.id)));
        },
    },
}
</script>

<style scoped>
  .option-content {
    display: flex;
    justify-content: space-between;
    align-items: justify;
    width: 100%;
  }

  .option-header {
    position: sticky;
    top:0;
    z-index: 1;
    background-color: #f2f2f2;
    border-radius: 10px;
  }

  .option-item {
    font-size: 13px;
    flex: 1;
    text-align: center;
    padding: 4px;
  }

  .option-item-1 {
    font-size: 13px;
    flex: 1;
    text-align: start;
    padding: 4px;
  }

  .option-item-2 {
    font-size: 13px;
    flex: 1;
    text-align: end;
    padding: 4px;
  }

  .back-option {
    border-bottom: 1px solid #eee;
    margin-bottom: 8px;
  }

  /* Tree select styling */
  .el-tree-select {
    width: 100%;
  }
</style>

